import {Provider} from '@angular/core';

import {
  ListProductUseCaseProvider
} from '@features/product/presentation/providers/list-product/list-product.use-case.provider';

import {ListProductFacade} from '@features/product/presentation/facades/list-product/list-product.facade';

export const ListProductFacadeProvider: Provider[] = [
  ListProductUseCaseProvider,
  ListProductFacade
];
